import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Done = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        fill="#303032"
        d="m9 16.2-3.5-3.5a.983.983 0 0 0-1.4 0 .984.984 0 0 0 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7a.984.984 0 0 0 0-1.4.986.986 0 0 0-1.4 0z"
      />
    </svg>
  );
};
export default Done;
